import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Token } from '../manager/token';
import { map } from 'rxjs/operators';
import { Observable, Subject,BehaviorSubject } from 'rxjs';
// import 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
@Injectable({
    providedIn: 'root'
})
export class AgentService {

    TokenCls
    instructionCountForMarquee: Subject<number> = new Subject<number>();
    changeBucket: Subject<any> = new Subject<any>();

    // pass inventory_Id for idecision menu
    idecisionInventoryId= new BehaviorSubject(0);

    private submitResultSource = new Subject<any>();
    submitResult$ = this.submitResultSource.asObservable();
    constructor(private http: HttpClient, private router: Router) {
        this.TokenCls = new Token(this.router);
    }

    GetAllFields(clientId, inventoryid, inventoryLogId, bucket_Name): any {
        return this.http.get(environment.ApiUrl + '/api/agent-fields/' + clientId + '/' + inventoryid + '/' + inventoryLogId + '/?bucket_Name=' + bucket_Name);
    }

    GetBucketsWithCount(ClientId: number): any {
        return this.http.get(environment.ApiUrl + '/api/agent-bucket-count/' + ClientId);
    }


    getAgentSaag(id):any {
        return this.http.get(environment.ApiUrl + '/api/agent-saag/client/' + id);
    }
    getClientUpdate(id):any {

        return this.http.get(environment.ApiUrl + '/api/agent-client-updates/client/' + id)
    }

    startBreak(value):any {
        return this.http.post(environment.ApiUrl + '/api/break-type', value)
    }

    endBreak(value):any {
        return this.http.put(environment.ApiUrl + '/api/break-type', value)
    }


    getMyStat(val):any {
        return this.http.get(environment.ApiUrl + '/api/agent-stats/client/' + val)
    }

    GetAccountList(client_id, bucket_name): any {

        return this.http.get(environment.ApiUrl + '/api/agent-account/' + client_id + '/?bucket_Name=' + bucket_name);
    }

    SaveAllFields(formobj): any {
        return this.http.put(environment.ApiUrl + '/api/agent-fields', formobj);
    }

    GetAllTouchedAccounts(clientId): any {
        return this.http.get(environment.ApiUrl + '/api/agent-account/' + clientId)
    }

    UpdateInventoryTime(formobj: any): any {
        console.log('UpdateInventoryTime formobj : ', formobj)
        return this.http.put(environment.ApiUrl + '/api/agent-time', formobj);
    }
    updateClientInstruction(data):any {
        return this.http.put(environment.ApiUrl + '/api/client-instruction-agent-accept', data)
    }
    GetCount(cid):any {
        return this.http.get(environment.ApiUrl + '/api/agent-client-updates-count/client/' + cid)

    }

    GetAllDenialCode(clientId, term: string): Observable<any> {
        return this.http.get(environment.ApiUrl + '/api/denial-code-lookup/client/' + clientId + '/?denial_code_char=' + term)
            .pipe(
                map(
                    (res:any) => {
                        var data = [];
                        data = res.Data;
                        return data

                    },
                    err => {
                        return [];
                    }
                )
            );
    }

    GetAllNPIList(ClientId: number, term: any):any {
        return this.http.get(environment.ApiUrl + '/api/npi-code-lookup/client/' + ClientId + '/?npi_char=' + term)
            .pipe(
                map(
                    (res:any) => {
                        var data = [];
                        data = res.Data;
                        return data

                    },
                    err => {
                        return [];
                    }
                )
            );
    }

    GetDenialDetails(clientId, denial_code):any {
        return this.http.get(environment.ApiUrl + '/api/denial-code-details-lookup/client/' + clientId + '/?denial_code=' + denial_code)
    }

    //fileapi
    CheckUploadedTemplate(ClientId: number, CurrentPayerName: string):any {
        return this.http.get(environment.FileApiUrl + '/api/agent-template/client/' + ClientId + '/' + CurrentPayerName)
    }

    UploadStaticFiles(dataobj):any {
        return this.http.post(environment.FileApiUrl + '/api/agent-template-upload', dataobj)
    }

    GeneratePdf(formobj):any {
        return this.http.post(environment.FileApiUrl + '/api/agent-template', formobj)
    }

    ReviewMergePdf(formobj):any {
        return this.http.post(environment.FileApiUrl + '/api/agent-merge-template', formobj)
    }
    //fileapi ends

    InsertEndTimeOfInventory(formobj):any {
        return this.http.post(environment.ApiUrl + '/api/agent-time', formobj)
    }

    ViewCommentHistory(Client_Id: any, Inventory_Id: any):any {
        return this.http.get(environment.ApiUrl + '/api/client-approval/client/' + Client_Id + '/' + Inventory_Id);
    }

    DeleteAppealFile(obj):any {
        return this.http.put(environment.FileApiUrl + '/api/agent-template-upload', obj)
    }
    getBCBSAssistance():any {
        return this.http.get(environment.ApiUrl + '/api/bcbs-assistance-data');
    }

    checkClientUserMappingButtonStatus():any {
        return this.http.get(environment.ApiUrl + '/api/set_Button_Visibility').pipe(map(res => res));
    }

    addNewLine(clientId,inventoryid,inventoryLogId,bucket_Name):any {
        // api/Get_Add_New_Line_Inventory_Details_For_Agent/{client_Id}/{inventory_Id}/{inventory_Log_Id}?bucket_Name=Special_Queue
        console.log('addNewLine() service : ');
        return this.http.get(environment.ApiUrl + `/api/Get_Add_New_Line_Inventory_Details_For_Agent/${clientId}/${inventoryid}/${inventoryLogId}?bucket_Name=${bucket_Name}`).pipe(map(res => res));
    }

    submitAddNewLine(body):any
    {
        return this.http.post(environment.ApiUrl + '/api/Save_Add_New_Line_Inventory_Details_For_Agent', body);
    }

    checkIfConcluder(clientId):any
    {
        // api/Check_Concluder_Process
        console.log('addNewLine() service : ');
        return this.http.get(environment.ApiUrl + `/api/Check_Concluder_Process?Client_Id=${clientId}`).pipe(map(res => res));
    }

    getConcluderInventoryData():any
    {
        // api/Get_Concluder_Inventory_data
        console.log('addNewLine() service : ');
        return this.http.get(environment.ApiUrl + `/api/Get_Concluder_Inventory_data`).pipe(map(res => res));
    }

    // api for update inventory time rework
    updateInventoryTimeRework(formobj: any): any {
      return this.http.put(environment.ApiUrl + '/api/agent-rework-time', formobj)
    }

    // api for insert inventory time rework
    insertEndTimeOfReworkInventory(formobj):any {
      return this.http.post(environment.ApiUrl + '/api/agent-rework-time', formobj)
  }

  // api for get multi grid data
  getAgentMultiGridList(clientId, bucket_Name): any {
    return this.http.get(environment.ApiUrl + '/api/agent-multiple-grid/client/' + clientId + '/?bucket_Name=' + bucket_Name);
  }

  // api for get single account for multi grid view button
  getAgentViewMultiGrid(clientId, inventory_Id, inventory_log_Id, bucket_Name): any {
    return this.http.get(environment.ApiUrl + '/api/agent-view-Multigrid/client/' + clientId + '/' + inventory_Id + '/' + inventory_log_Id + '/?bucket_Name=' + bucket_Name);
  }

  saveSpecialQueueAllFields(clientId, bucket_Name, formobj): any {
    return this.http.put(environment.ApiUrl + '/api/agent-multiple-grid/client/' + clientId + '/?bucket_Name=' + bucket_Name, formobj);
  }

  SaveagentOthersmultiplegrid(clientId, queue_Id,  formobj): any {
    return this.http.put(environment.ApiUrl + '/api/agent-Others-multiple-grid/client/' + clientId + '/?Queue_Id=' + queue_Id,formobj);
  }
  // iDecisionTreeURL
  iDecisionTreeURL(formobj){
    return this.http.post(environment.ApiUrl + '/api/iDecisionTreeURL', formobj)
  }
// to get EOB pdf in RFF Queue
  GetEOBpdf(clientId,patientName,dos, accountNumber,inventoryId){
  return this.http.get(environment.ApiUrl + '/api/Get_FileURL/' + clientId + '/' + patientName + '/' + dos + '/' + accountNumber + '/' + inventoryId);

  }

  getagentOthersviewMultigrid(clientId, inventory_Id, inventory_log_Id, Queue_ID): any {
    return this.http.get(environment.ApiUrl + '/api/agent-Others-view-Multigrid/client/' + clientId + '/' + inventory_Id + '/' + inventory_log_Id + '/?_queue_Id=' + Queue_ID);
  }
 

    notifySubmit(result: any) {
    this.submitResultSource.next(result);
    }
}
